import axios from '@/lib/axios'

import { JWT_ACCESS_TOKEN_KEY } from './constant'

// ----------------------------------------------------------------------

export function jwtDecode(token: string) {
  try {
    if (!token) return null

    const parts = token.split('.')
    if (parts.length < 2) {
      throw new Error('Invalid token!')
    }

    const base64Url = parts[1]
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
    const decoded = JSON.parse(atob(base64))

    return decoded
  } catch (error) {
    console.error('Error decoding token:', error)
    throw error
  }
}

// ----------------------------------------------------------------------

export function isValidToken(accessToken: string) {
  if (!accessToken) {
    return false
  }

  try {
    const decoded = jwtDecode(accessToken)

    if (!decoded || !('exp' in decoded)) {
      return false
    }

    const currentTime = Date.now() / 1000

    return decoded.exp > currentTime
  } catch (error) {
    console.error('Error during token validation:', error)
    return false
  }
}

export function setSession(accessToken: string | null) {
  try {
    if (accessToken) {
      localStorage.setItem(JWT_ACCESS_TOKEN_KEY, accessToken)
      axios.defaults.headers.common.Authorization = `Bearer ${accessToken}`
    } else {
      localStorage.removeItem(JWT_ACCESS_TOKEN_KEY)
      sessionStorage.removeItem(JWT_ACCESS_TOKEN_KEY)
      delete axios.defaults.headers.common.Authorization
    }
  } catch (error) {
    console.error('Error during set session:', error)
    throw error
  }
}
